/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpinWheelSegment
 */
export interface SpinWheelSegment {
    /**
     * 
     * @type {string}
     * @memberof SpinWheelSegment
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelSegment
     */
    color: string;
}

/**
 * Check if a given object implements the SpinWheelSegment interface.
 */
export function instanceOfSpinWheelSegment(value: object): value is SpinWheelSegment {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function SpinWheelSegmentFromJSON(json: any): SpinWheelSegment {
    return SpinWheelSegmentFromJSONTyped(json, false);
}

export function SpinWheelSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWheelSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'color': json['color'],
    };
}

export function SpinWheelSegmentToJSON(json: any): SpinWheelSegment {
    return SpinWheelSegmentToJSONTyped(json, false);
}

export function SpinWheelSegmentToJSONTyped(value?: SpinWheelSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'color': value['color'],
    };
}

